import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http'; // <-- Importado para tipar el error
import { GeneralService } from '../../shared/services/general.service';
import { UserService } from '../../shared/services/user.service';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { InputGeneral } from '../../shared/inputs/input-general/input-general';
import { CustomWindow } from '../../shared/models/auth-model/auth.model'; // <-- Importamos la interfaz CustomWindow

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatDialogModule,
    LoadGeneralComponent,
    InputGeneral,
  ],
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit {
  isLoading: boolean = false;
  tokenUser: string | null = null;
  userId: number = 0;
  isTokenValid: boolean = false;

  public newPassword: FormControl = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.minLength(8)],
  });
  public confirmPassword: FormControl = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required],
  });

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private generalService: GeneralService,
  ) {
  }

  ngOnInit(): void {
    this.tokenUser = this.route.snapshot.paramMap.get('token');
    if (!this.tokenUser) {
      this.generalService.viewSnacAlert('errorMessages.missingToken', 'error', 'labels.error');
      this.router.navigate(['/login']);
      return;
    }

    this.validateToken();
  }

  public validateToken() {
    this.isLoading = true;

    this.userService.validateUserToken(this.tokenUser!).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.isTokenValid = true;

        if (res && res.userId) {
          this.userId = res.userId;
        }
      },
    });
  }

  public changePassword() {
    if (this.newPassword.value !== this.confirmPassword.value) {
      this.generalService.viewSnacAlert(
        'users.messages.passwordMismatch',
        'error',
        'users.labels.error',
      );
      return;
    }

    this.isLoading = true;

    const changePasswordRequest = {
      userId: this.userId,
      newPassword: this.newPassword.value,
      isWeb: true,
    };

    this.userService.changePassword(changePasswordRequest).subscribe({
      next: () => {
        this.isLoading = false;

        this.generalService.viewSnacAlert(
          'users.messages.passwordChangedSuccess',
          'normal',
          'users.labels.success',
        );

        this.router.navigate(['/login']);
      },
      // 4. Tipamos el error con HttpErrorResponse
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;

        if (error.error === 'IpNotAuthorized') {
          this.generalService.viewSnacAlert(
            'errorMessages.ipNotAuthorized',
            'error',
            'labels.error',
          );
        } else {
          this.generalService.viewSnacAlert(
            'errorMessages.changePasswordFailed',
            'error',
            'labels.error',
          );
        }
      },
    });
  }

  public getControl(formGroup: FormGroup, key: string): FormControl {
    return formGroup.get(key) as FormControl;
  }
}
